/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.profiles.rpc.ProfilesPublicRpc
 */
import * as References from './ProfilesPublicRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.profiles.rpc.ProfilesPublicRpc#getProfile
 */
export const GET_PROFILE_QUERY_FIELD_NAME = 'com_hubspot_marketplace_profiles_rpc_ProfilesPublicRpc_getProfile';
export const GET_PROFILE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PROFILE_QUERY_FIELD_NAME,
  args: ['slug'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getProfileRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});